<template>
  <section>
    <!--工具条-->
    <div>
      <el-form :inline="true">
        <el-form-item label="客户名称">
          <el-input v-model="filters.clientName" placeholder="客户名称"></el-input>
        </el-form-item>
        <el-form-item label="工程名称">
          <el-input v-model="filters.projectName" placeholder="工程名称"></el-input>
        </el-form-item>
        <el-form-item label="强度等级">
          <el-input v-model="filters.gradeName" placeholder="强度等级"></el-input>
        </el-form-item>
        <el-form-item label="浇筑方式">
          <el-input v-model="filters.pouringMethodName" placeholder="浇筑方式"></el-input>
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input v-model="filters.code" placeholder="单据编号"></el-input>
        </el-form-item>
        <el-form-item label="施工部位">
          <el-input v-model="filters.projectPart" placeholder="施工部位"></el-input>
        </el-form-item>
        <el-form-item label="车号">
          <el-input v-model="filters.vehicleErpCode" placeholder="车号"></el-input>
        </el-form-item>
        <el-form-item label="生产线">
          <el-input v-model="filters.stationLineName" placeholder="生产线"></el-input>
        </el-form-item>
        <el-form-item label="工控机编号">
          <el-input v-model="filters.plcOutMasterCode" placeholder="工控机编号"></el-input>
        </el-form-item>
        <el-form-item label="任务单号">
          <el-input v-model="filters.taskCode" placeholder="任务单号"></el-input>
        </el-form-item>
        <el-form-item label="发货时间">
          <el-date-picker type="datetime" placeholder="开始日期" v-model="filters.startTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          <el-date-picker type="datetime" placeholder="结束日期" v-model="filters.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        
        <el-form-item label="是否打印">
          <el-select v-model="filters.printCount" placeholder="是否打印">
            <el-option label="所有单据" :value="-1"></el-option>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getReportList(1)">查询</el-button>
          <el-button type="primary" @click="downReport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--列表-->
    <el-table :data="dmList" highlight-current-row v-loading="listLoading" style="width: 100%" border show-summary
      :summary-method="getSummaries">
      
      <el-table-column prop="Code" label="出货单号"></el-table-column>
      <el-table-column prop="ProductionTime" label="日期" :formatter="formatTimeYMD"></el-table-column>
      <el-table-column prop="ProductionTime" label="时间" :formatter="formatTimeHMS"></el-table-column>
      <el-table-column prop="ClientName" label="客户名称"></el-table-column>
      <el-table-column prop="ProjectName" label="工程名称"></el-table-column>
      <el-table-column prop="GradeName" label="强度等级"></el-table-column>
      <el-table-column prop="SpecMtlName" label="特殊材料"></el-table-column>
      <el-table-column prop="PouringMethodName" label="浇筑方式"></el-table-column>
      <el-table-column prop="ProjectPart" label="施工部位"></el-table-column>
      <el-table-column prop="VehicleErpCode" label="搅拌车号"></el-table-column>
      <el-table-column prop="License" label="搅拌车牌"></el-table-column>
      <el-table-column prop="DriverName" label="驾驶员" width="80"></el-table-column>
      <el-table-column prop="PumpingDriverName" label="泵车司机" width="80"></el-table-column>
      <el-table-column label="生产方量" width="80">
        <template slot-scope="scope">
          <div>
            {{ Number(scope.row.TQuantity) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="QuantityDelivery" label="发货方量"></el-table-column>
      <el-table-column prop="VehiclesTotal" label="累计车次"></el-table-column>
      <el-table-column prop="QuantityTotal" label="累计方量"></el-table-column>
      <el-table-column prop="StationLineName" label="生产线"></el-table-column>
      <el-table-column prop="PrintCount" label="打印次数"></el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="filters.intPageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>
  </section>
</template>

<script>
//引入Material.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/command";
import Toolbar from "../../components/Toolbar";
import util from "../../../util/date";
export default {
  components: { Toolbar },
  data() {
    return {
      currentRow: null,
      filters: {
        startTime: "",
        endTime: "",
        clientName: "",
        projectName: "",
        gradeName: "",
        pouringMethodName: "",
        code: "",
        projectPart: "",
        vehicleErpCode: "",
        stationLineName: "",
        plcOutMasterCode: "",
        taskCode: "",
        page: 1,
        intPageSize: 20,
        printCount: -1
      },
      total: 0,
      dmList: [],
      sumData: {},
      listLoading: false,
    };
  },
  computed: {},
  methods: {
    getSummaries(param) {
      var sums = [];
      sums[0] = "合计";
      sums[1] = "";
      sums[2] = "";
      sums[3] = "";
      sums[4] = "";
      sums[5] = "";
      sums[6] = "";
      sums[7] = "";
      sums[8] = "";
      sums[9] = "";
      sums[10] = "";
      sums[11] = "";
      sums[12] = "";
      sums[13] = this.sumData.TQuantity;
      sums[14] =  this.sumData.QuantityDelivery;
      sums[15] ="";
      sums[16] = "";
      sums[17] = "";
      sums[18] = "";

      return sums;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.filters.page = val;
      this.getReportList();
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.filters.intPageSize = size;

      this.getReportList(1);
    },
    //获取原材料消耗
    getReportList(optype) {
      if (optype == 1) {
        this.filters.page = 1;
      }
      let para = this.filters;
      this.listLoading = true;
      this.dmList = [];
      api
        .GetProdOutMasterDetail(para)
        .then((res) => {
          if (res && res.data && res.data.response && res.data.response.data)
            this.dmList = res.data.response.data;
          this.sumData = res.data.responsesum;
          this.total = res.data.response.dataCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //导出原材料消耗
    downReport() {
      let para = this.filters;
      var sheetName = "生产明细表";
      api.DownProdOutMasterDetail(para, sheetName).then((res) => { });
    },
    formatTimeYMD(row, column) {
      return !row.ProductionTime || row.ProductionTime == ""
        ? ""
        : util.formatDate.format(new Date(row.ProductionTime), "yyyy/MM/dd");
    },
    formatTimeHMS(row, column) {
      return !row.ProductionTime || row.ProductionTime == ""
        ? ""
        : util.formatDate.format(new Date(row.ProductionTime), "hh:mm:ss");
    }, formatDate(date) {
      function padZero(num) {
        return num < 10 ? '0' + num : num;
      }
      var year = date.getFullYear();
      var month = padZero(date.getMonth() + 1); // 月份是从0开始的
      var day = padZero(date.getDate());
      var hours = padZero(date.getHours());
      var minutes = padZero(date.getMinutes());
      var seconds = padZero(date.getSeconds());

      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    },
  },
  mounted() {
    let pastDate = new Date(new Date().setHours(0, 0, 0, 0));
    pastDate.setDate(pastDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.startTime = this.formatDate(pastDate);

    let endDate = new Date(new Date().setHours(23, 59, 59, 0));
    endDate.setDate(endDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.endTime = this.formatDate(endDate);
    this.getReportList();
  },
};
</script>

<style lang="less" scoped>
.input-select {
  width: 300px;
}
</style>
